export enum PartEnum {
    '2_part' = '2 Part',
    '4_part' = '4 Part',
    '1P' = '1P',
    '3P'='3P',
    '1P_WITH_LOGO' = '1P WITH LOGO',
    '2P' = '2P',
    '2P_WITH_LOGO' = '2P WITH LOGO',
    '4P' = '4P',
    '4P_WITH_LOGO' = '4P WITH LOGO',
    '6P' = '6P',
    '6P_WITH_LOGO' = '6P WITH LOGO',
}

export enum VendorType {
    'Fabric' = 'Fabric',
    'Trim' = 'Trim',
}

export const PartEnumDisplay = [
    { name: "2_part", displayVal:'2 Part'},
    { name:'4_part', displayVal:'4 Part'},
    { name:'1P', displayVal:'1P'},
    { name:'3P', displayVal:'3P'},

    { name:'1P_WITH_LOGO', displayVal:'1P WITH LOGO'},
    { name:'2P', displayVal:'2P'},
    { name:'2P_WITH_LOGO', displayVal:'2P WITH LOGO'},
    { name:'4P', displayVal:'4P'},
    { name:'4P_WITH_LOGO', displayVal:'4P WITH LOGO'},
    { name:'6P', displayVal:'6P'},
    { name:'6P_WITH_LOGO', displayVal:'6P WITH LOGO'},

]

